<!-- dynamic-form.component.html -->

@if(loader){<app-loader></app-loader>}
@else{<div style="height: 4px;"></div>}
<div class="request-editor__main">
    <div class="d-flex align-items-center w-100">
        <button class="get">GET</button>
        <input [(ngModel)]="api_end_point" disabled [ngModelOptions]="{standalone: true}" type="text"
            placeholder="Enter URL or paste text" class="form-control">
    </div>
    <button type="submit" (click)="onSubmit()" class="send">Send</button>
</div>
<div class="d-flex align-items-center w-100 nav-btn">
    <button [class.active]="selected_view == 'Params'" (click)="changeSelection('Params')">
        <h3 class="f-w-500">Input Parameter</h3>
    </button>
    <button [class.active]="selected_view == 'Response'" (click)="changeSelection('Response')">
        <h3 class="f-w-500">Response</h3>
    </button>
</div>

@if(selected_view == 'Params'){
<form [formGroup]="form">
    <div>
        <div class="api-ui">
            <div class="d-flex align-items-center mb-2 headers gap-05">
                <label>API Key <span class="danger">*</span></label>
                <input [(ngModel)]="api_key" disabled [ngModelOptions]="{standalone: true}" type="text"
                    class="form-control" />
            </div>
            <div class="d-flex align-items-center mb-2 headers gap-05">
                <label>User Token <span class="danger">*</span></label>
                <input [(ngModel)]="user_token" disabled [ngModelOptions]="{standalone: true}" type="text"
                    class="form-control" />
            </div>
            @if(type==='buildings' || type === 'floors' || type === 'units' || type === 'transactions' || type === 'avm_api'){
            <div class="d-flex align-items-center mb-2 headers gap-05">
                <label>City Code <span class="danger">*</span></label>
                <input [(ngModel)]="city_code"  [ngModelOptions]="{standalone: true}" type="text"
                    class="form-control" />
            </div>
            }
        </div>
        <div class="api-ui">
            @for(param of formConfig.params; track param){
                @if (param.type === DataType.Number) {
                <div class="d-flex align-items-center mb-2 headers gap-05">
                    <label>{{ param.label }} @if(param?.required){<span class="danger">*</span>}
                        @if(param?.description){<span class="description">{{param?.description}}</span>}</label>
                    <input [formControlName]="param.attribute" type="number" (keyup)="onChange()" [min]="1"
                        (keydown)="restrictNegativeAndZero($event)" class="form-control"
                        [ngClass]="{ 'input-error': form.get(param.attribute)?.invalid && form.get(param.attribute)?.touched }" />
                    @if(param.attribute == 'lat'){<mat-icon class="map-icon" (click)="openMapBox()" [matTooltipPosition]="'above'" matTooltip="Click to pick coordinates from the map">map</mat-icon>}
                </div>
                }
                @if (param.type === DataType.String) {
                <div class="d-flex align-items-center mb-2 headers gap-05">
                    <label>{{ param.label }} @if(param?.required){<span class="danger">*</span>}
                        @if(param?.description){<span class="description">{{param?.description}}</span>}</label>
                    <input [formControlName]="param.attribute" type="text" (keyup)="onChange()"
                         class="form-control" />
                </div>
                }
                <!-- @if (param.type === DataType.Date) {
                <div class="d-flex align-items-center mb-2 headers gap-05">
                    <label>{{ param.label }} @if(param?.required){<span class="danger">*</span>}
                        @if(param?.description){<span class="description">{{param?.description}}</span>}</label>
                         <div class="d-flex align-items-center">
                            <div (click)="startPicker.open()" style="direction: ltr; position: relative;" >
                                <input placeholder="Choose Date"  class="form-control"  [matDatepicker]="startPicker" [min]="minStartDate"
                                [formControlName]="param.attribute" readonly/>
                                <mat-datepicker-toggle matSuffix [for]="startPicker" style="position: absolute; right: -3px; top: -6px;" ></mat-datepicker-toggle>
                                <mat-datepicker  #startPicker></mat-datepicker>
                            </div>
                            <small class="clear-text" (click)="cleartext(param.attribute)">Clear</small>
                         </div>
                </div>
                } -->
                
                @if (param.type === DataType.DateRange  && param.attribute == "date") {
                <div class="d-flex align-items-center mb-2 headers gap-05">
                    <label>{{ param.label }} @if(param?.required){<span class="danger">*</span>}
                    @if(param?.description){<span class="description">{{param?.description}}</span>}</label>
                    <div class="date-range">
                        <div class="d-flex align-items-center">
                            <div  (click)="startPickeraF.open()" style="direction: ltr; position: relative;" >
                                <input (dateChange)="onChange()" placeholder="Choose Start Date"  class="form-control"  [matDatepicker]="startPickeraF" 
                                    [min]="minStartDate"
                                    [(ngModel)]="start_date_f" [ngModelOptions]="{standalone: true}" readonly/>
                                <mat-datepicker-toggle matSuffix [for]="startPickeraF" style="position: absolute; right: -3px; top: -6px;" ></mat-datepicker-toggle>
                                <mat-datepicker  #startPickeraF></mat-datepicker>
                            </div>
                        </div>
                        <div class="d-flex align-items-center">
                            <div  (click)="startPickerbF.open()" style="direction: ltr; position: relative;" >
                                <input (dateChange)="onChange()" placeholder="Choose End Date"  class="form-control"  [matDatepicker]="startPickerbF" 
                                    [min]="start_date_f" 
                                    [(ngModel)]="end_date_f" [ngModelOptions]="{standalone: true}" readonly/>
                                <mat-datepicker-toggle matSuffix [for]="startPickerbF" style="position: absolute; right: -3px; top: -6px;" ></mat-datepicker-toggle>
                                <mat-datepicker  #startPickerbF></mat-datepicker>
                            </div>
                            <small class="clear-text" (click)="cleartext('date-range', param.attribute)">Clear</small>
                        </div>                            
                    </div>
                </div>
                }
                @if (param.type === DataType.DateRange && param.attribute == "transaction_date") {
                <div class="d-flex align-items-center mb-2 headers gap-05">
                    <label>{{ param.label }} @if(param?.required){<span class="danger">*</span>}
                    @if(param?.description){<span class="description">{{param?.description}}</span>}</label>
                    <div class="date-range">
                        <div class="d-flex align-items-center">
                            <div  (click)="startPickera.open()" style="direction: ltr; position: relative;" >
                                <input (dateChange)="onChange()" placeholder="Choose Start Date"  class="form-control"  [matDatepicker]="startPickera" 
                                    [min]="minStartDate"
                                    [(ngModel)]="start_date" [ngModelOptions]="{standalone: true}" readonly/>
                                <mat-datepicker-toggle matSuffix [for]="startPickera" style="position: absolute; right: -3px; top: -6px;" ></mat-datepicker-toggle>
                                <mat-datepicker  #startPickera></mat-datepicker>
                            </div>
                        </div>
                        <div class="d-flex align-items-center gap-05">
                            <div  (click)="startPickerb.open()" style="direction: ltr; position: relative;" >
                                <input (dateChange)="onChange()" placeholder="Choose End Date"  class="form-control"  [matDatepicker]="startPickerb" 
                                    [min]="start_date" 
                                    [(ngModel)]="end_date" [ngModelOptions]="{standalone: true}" readonly/>
                                <mat-datepicker-toggle matSuffix [for]="startPickerb" style="position: absolute; right: -3px; top: -6px;" ></mat-datepicker-toggle>
                                <mat-datepicker  #startPickerb></mat-datepicker>
                            </div>
                            <small class="clear-text" (click)="cleartext('date-range', param.attribute)">Clear</small>
                        </div>                            
                    </div>
                </div>
                }
            }
        </div>
        @if(formConfig.filters){
        <h3>Filter</h3>
        <div class="parameter-list row">
            <div class="col-lg-6">
                <div class="grouping filter-body">
                    @for(field of formConfig.filters; track field){
                    <div class="api-ui">

                        @if (field.type === DataType.Number) {
                        <div class="d-flex align-items-center mb-2">
                            <label>{{ field.label }} @if(field?.description){<span
                                    class="description">{{field?.description}}</span>}</label>

                            <input [formControlName]="field.attribute" type="number" [min]="1"
                                (keydown)="restrictNegativeAndZero($event)" (keyup)="onChange()" class="form-control" />
                        </div>
                        }
                        @if (field.type === DataType.Boolean) {
                        <div class="d-flex align-items-center mb-2">
                            <label>{{ field.label }} 
                                 @if(field?.required){<span class="danger">*</span>}
                                 @if(field?.description){<span
                                    class="description">{{field?.description}}</span>}</label>

                            <mat-select [formControlName]="field.attribute" class="form-control p-0"
                                (selectionChange)="onChange()">
                                @for(option of field?.data; track option){
                                <mat-option [value]="option.value">
                                    {{ option.label }}
                                </mat-option>
                                }
                            </mat-select>
                        </div>
                        }
                        @if (field.type === DataType.String) {
                        <div class="d-flex align-items-center mb-2">
                            <label>{{ field.label }} @if(field?.description){<span
                                    class="description">{{field?.description}}</span>}</label>
                            <input [formControlName]="field.attribute" type="string" class="form-control"
                            (keyup)="onChange()" />
                        </div>
                        }
                        @if (field.type === DataType.Date) {
                           <div class="d-flex align-items-center mb-2">
                            <label>{{ field.label }} @if(field?.description){<span
                                    class="description">{{field?.description}}</span>}</label>
                            <div  (click)="startPicker.open()" style="direction: ltr; position: relative;" >
                                <input placeholder="Choose Date"  class="form-control"  [matDatepicker]="startPicker" [min]="minStartDate"
                                name = "startDate"[formControlName]="field.attribute" readonly/>
                                <mat-datepicker-toggle matSuffix [for]="startPicker" style="position: absolute; right: -3px; top: -6px;" ></mat-datepicker-toggle>
                                <mat-datepicker  #startPicker></mat-datepicker>
                            </div>
                        </div>
                        }
                    </div>
                    }
                </div>
                <div class="grouping" *ngIf="formConfig?.construction">
                    <span class="title">Construction</span>
                    <mat-radio-group aria-labelledby="example-radio-group-label" formControlName="construction"
                        (change)="onChange()">
                        @for(field of formConfig.construction; track field){
                        <div class="api-ui">
                            <div class="d-flex align-items-center mb-2">
                                <mat-radio-button class="custom-radio" color="primary" [value]="field.value"> {{ field.label
                                    }}</mat-radio-button>
                            </div>
                        </div>
                        }
                    </mat-radio-group>
                </div>
                <div class="grouping" *ngIf="formConfig?.finishType">
                    <span class="title">Finishing Type</span>
                    <mat-radio-group aria-labelledby="example-radio-group-label" formControlName="construction"
                        (change)="onChange()">
                        @for(field of formConfig.finishType; track field){
                        <div class="api-ui">
                            <div class="d-flex align-items-center mb-2">
                                <mat-radio-button class="custom-radio" color="primary" [value]="field.value"> {{ field.label
                                    }}</mat-radio-button>
                            </div>
                        </div>
                        }
                    </mat-radio-group>
                </div>
            </div>
            <div class="col-lg-6" >
                <div class="grouping" *ngIf="formConfig?.units">
                    <span class="title">Units</span>
                    <mat-radio-group aria-labelledby="example-radio-group-label" formControlName="unit"
                        (change)="onChange()">
                        @for(field of formConfig.units; track field){
                        <div class="api-ui">
                            <div class="d-flex align-items-center mb-2">
                                <mat-radio-button class="custom-radio" color="primary" [value]="field.value">{{ field.label
                                    }}</mat-radio-button>
                            </div>
                        </div>
                        }
                    </mat-radio-group>
                </div>
                <div class="grouping" *ngIf="formConfig.property">
                    <span class="title">Property</span>
                    <mat-radio-group aria-labelledby="example-radio-group-label" formControlName="property"
                        (change)="onChange()">
                        @for(field of formConfig.property; track field){
                        <div class="api-ui">
                            <div class="d-flex align-items-center mb-2">
                                <mat-radio-button class="custom-radio" color="primary" [value]="field.value">{{ field.label
                                    }}</mat-radio-button>
                            </div>
                        </div>
                        }
                    </mat-radio-group>
                </div>
            </div>
        </div>
        }
        
    </div>
</form>
}

@if(selected_view == 'Response'){
<div class="response row">
    <div class="col-lg-12">
        @if (response) {
           @if(type == 'avmRental') {
            <app-response-avm-rental [response]="response"></app-response-avm-rental>
           }
            @if(type == 'commercial') {
            <app-response-commercial-rental [response]="response"></app-response-commercial-rental>
           }
            @if(type == 'office_property') {
            <app-response-commercial-data [response]="response"></app-response-commercial-data>
           }
            @if(type == 'avm_data') {
            <app-response-avm-data [response]="response"></app-response-avm-data>
           }
            @if(type == 'nearby_data') {
            <app-response-nearby-data [response]="response"></app-response-nearby-data>
           }
            @if(type == 'buildings') {
            <app-response-buildings-data [response]="response"></app-response-buildings-data>
           }
            @if(type == 'floors') {
            <app-response-floors-data [response]="response"></app-response-floors-data>
           }
            @if(type == 'units') {
            <app-response-units-data [response]="response"></app-response-units-data>
           }
            @if(type == 'transactions') {
            <app-response-transactions-data [response]="response"></app-response-transactions-data>
           }
             @if(type == 'avm_api') {
            <app-response-avm-api [response]="response"></app-response-avm-api>
           }
           @if(type == 'nearby_apidata') {
            <app-response-nearby-api [response]="response"></app-response-nearby-api>
           }
        }@else {
        @if(is_requested){
        <div class="text-center">No results found</div>
        }
        }
    </div>
    <div class="col-lg-12">
        @if (response) {
        <div class="est-js-code">
            <pre><code>{{response | json}}</code></pre>
        </div>
        }
    </div>
</div>
}
